export default "__VITE_ASSET__CiThu5Iv__"